module.exports = __webpack_public_path__ + "static/media/oasis.46a2f3f7.png";